<template>
  <div class="list">
    <list-header :complete-count="completeCount" :assign-count="assignCount"></list-header>
    <div class="content flex-content-between">
      <answer-area
        :active-answer="activeAnswer"
        :active-ques-info="activeQuesInfo"
      ></answer-area>
      <score-area
        :progress-list="progressList"
        :active-no="activeNo"
        :active-ques-info="activeQuesInfo"
        :active-answer="activeAnswer"
        :is-first="isFirst"
        :is-done="isDone"
        @changeQuesNo="changeQuesNo"
        @submit="submitScore"
        @changeTask="changeTask"
        @judgeBack="judgeBack"
        @changeStudentID="changeStudentID"
      ></score-area>
    </div>
    <div class="loading-mask" v-if="loading">
      <loading
        :box-size="16"
        :round-size="4"
        :color="'#306FFF'"></loading>
    </div>
    <Modal
      width="330px"
      speed="fast"
      noOutClose
      maskNoClick
      noClose
      noHeader
      noFooter
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="showDoneModal = false"
      :show="showDoneModal"
      class="done-modal"
    >
      <div slot="content">
        <span class="icon-done"></span>
        <p>阅卷完成！</p>
        <button class="btn" @click="showDoneModal = false">知道了</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ListHeader from './ListHeader'
import ScoreArea from './ScoreArea'
import AnswerArea from './AnswerArea'
import { get, post } from '@/utils/ajax'
import Loading from '@/components/Loading'
import Modal from '@/components/Modal'
export default {
  components: {
    ListHeader,
    ScoreArea,
    AnswerArea,
    Loading,
    Modal
  },
  data() {
    return {
      markingId: null,
      judgeId: null,
      completeCount: 0,
      assignCount: 0,
      progressList: [],
      allQuesInfo: [],
      loading: false,
      activeNo: 0,
      activeQuesInfo: {},
      activeAnswer: {},
      activeTaskId: null,
      showDoneModal: false,
      isFirst: false,
      isDone: false
    }
  },
  watch: {
    activeNo(val) {
      this.initQuesInfo()
    }
  },
  async mounted() {
    this.markingId = this.$route.query.id
    this.judgeId = this.$route.query.judgeId
    this.loading = true
    await this.getProgress()
    await this.getAllQuesInfo()
    this.loading = false
  },
  methods: {
    // 获取当前批改进度
    async getProgress() {
      const { total, done, party } = await get(`/home/judges/${this.judgeId}/progress`)
      this.completeCount = done
      this.assignCount = total
      this.progressList = party
      this.isFirst = done === 0
      this.isDone = done === total
    },
    // 获取所有固定题目结构
    async getAllQuesInfo() {
      const { niceBasketId, questions } = await get(`/home/marking/${this.markingId}/questions?judgeId=${this.judgeId}`)
      this.allQuesInfo = questions
      if (!questions.length) {
        this.$message.warning('该试卷还未分配阅卷任务！')
        this.$router.push({ name: 'judgeSelect' })
      } else {
        const recordId = this.$route.query.recordId
        if (recordId) { // 从阅卷记录进入
          await this.getActiveAnswer(recordId)
        } else {
          await this.getActiveAnswer(niceBasketId) // 初始化第一个任务
        }
      }
    },
    // 切换题号
    async changeQuesNo(no) {
      this.loading = true
      const { marking_basket_id } = await get(`/home/judges/${this.judgeId}/switch?questionNo=${no}`)
      await this.getActiveAnswer(marking_basket_id)
      this.loading = false
    },
    // 根据当前题号提取固定的题目信息和结构
    initQuesInfo() {
      for (let i = 0; i < this.allQuesInfo.length; i++) {
        if (this.allQuesInfo[i].questionNo === this.activeNo) {
          this.activeQuesInfo = this.allQuesInfo[i]
          break
        }
      }
    },
    // 获取当前任务id的所有信息
    async getActiveAnswer(id) {
      this.activeAnswer = await get(`/home/judges/baskets/${id}`)
      this.activeTaskId = id
      this.activeNo = this.activeAnswer.questionNo
    },
    // 提交批改
    async submitScore(scores, mark, isEdit, noPointScore) {
      this.loading = true
      const params = {
        judge_id: this.judgeId,
        marking_basket_id: this.activeTaskId,
        items: scores,
        note: mark,
        score: noPointScore
      }
      try {
        const { marking_basket_id, current_all_done } = await post(`/home/judges/score`, params)
        this.$message.success('提交成功！')
        if (current_all_done && !isEdit) { // 任务全部批改完
          this.showDoneModal = true
          await this.getProgress()
          await this.getActiveAnswer(this.activeTaskId)
        }
        if (!current_all_done && !isEdit) { // 如果不是最后一题/修改，就自动拉下一个任务
          await this.getActiveAnswer(marking_basket_id)
          await this.getProgress()
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    // 切换任务
    async changeTask(flag) {
      this.loading = true
      try {
        this.activeAnswer = await get(`/home/marking/${this.activeTaskId}/changes?change=${flag}`)
        this.activeNo = this.activeAnswer.questionNo
        this.activeTaskId = this.activeAnswer.id
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    // 回到当前答题
    async judgeBack(no) {
      this.loading = true
      const { marking_basket_id } = await get(`/home/judges/${this.judgeId}/back?questionNo=${no}`)
      await this.getActiveAnswer(marking_basket_id)
      this.loading = false
    },
    // 切换考生ID
    async changeStudentID(userId) {
      this.loading = true
      try {
        this.activeAnswer = await get(`/home/marking/${this.markingId}/${this.activeAnswer.questionId}/${userId}`)
        this.activeTaskId = this.activeAnswer.id
        this.activeNo = this.activeAnswer.questionNo
      } catch (error) {
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    min-width: 1400px;
    height: 100%;
    position: relative;
  }
  .content {
    height: calc(100% - 64px);
  }
  .loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 5;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .done-modal {
    font-size: 14px;
    color: #333;
    text-align: center;
    /deep/ .content {
      text-align: center;
    }
    .icon-done {
      display: inline-block;
      width: 54px;
      height: 55px;
      background: url('~@/assets/images/judge/icon-done.png') center / cover no-repeat;
      margin: 20px 0 5px 0;
    }
    .btn {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
      margin-top: 32px;
      margin-bottom: 10px;
    }
  }
</style>
